export enum PPC_PAGE_TITLE {
  HOME = 'Home',
  CUSTOMERS = 'Customers',
  INVOICES = 'Invoices',
  CATALOG = 'Catalog',
  SUBSCRIPTIONS = 'Subscriptions',
  BILLING_ACCOUNT = 'Billing account',
  ACCOUNT_CREDIT_BALANCE = 'Account credit balance',
  EMAIL_DETAILS = 'Email details',
  ADD_PAYMENT_METHOD = 'Add Payment Method',
  QUOTES = 'Quotes',
  ORDER = 'Order and estimate',
  REVIEW_ORDER = 'Review order',
  ORDER_RECEIVED = 'Order received',
  ORGANISATION = 'Organisation',
  INTERNAL_USAGE_SUBSCRIPTIONS = 'Internal usage subscriptions',
  DEAL_REGISTRATIONS = 'Deals',
}
